export default {
  date: 'January 10, 2025',
  title: 'January Special: Old Prices All Month Long!',
  description: 'This January, take advantage of a unique opportunity to purchase packages of 5 to 50 floor plans at last year’s prices and top up your Getfloorplan account.',
  id: 'january-special',
  jsx: () => (
    <div class='novelty__text'>
      <p>This January, take advantage of a unique opportunity to purchase packages of 5 to 50 floor plans at last year’s prices and top up your Getfloorplan account.</p>
      <p>
        <b>What does this mean?</b>
      </p>
      <p>
        You can choose any of our packages, including <b>Plus, Render, Max,</b> or others — for example, <b>15 units of the Basic package</b> — and buy them at a discounted price.
      </p>
      <p>
        <b>Benefits of this offer:</b>
      </p>
      <ul style='margin-left: 50px'>
        <li class='margin-none'>
          Purchased packages are <b>valid indefinitely</b>, so you can use them at any time.
        </li>
        <li class='margin-none'>
          After topping up your account, you’ll receive a<b>unique promo code</b> to use when creating your floor plans.
        </li>
      </ul>
      <p>
        <b>Offer validity:</b>
      </p>
      <p>
        This offer is available until <b>January 31st.</b>
      </p>
      <p>
        <b>How to claim this offer:</b>
      </p>
      <p>
        Email us at
        <a href='mailto:customerservice@getfloorplan.com'> customerservice@getfloorplan.com</a>, and our manager will guide you through the purchase process.
      </p>
      <p>
        <b>Don’t miss this opportunity to save! This special offer is valid only in January.</b>
      </p>
    </div>
  ),
  thumb: 'news/35.webp',
};
